import type { IContextPageConfigTab } from "../../ProjectSettings";
import { IContextInformation } from "../matrixlib/MatrixLibInterfaces";

export type { IContextFramePlugin };
export { ContextFrameManager };
export { InitializeTrainingManager };

interface IContextFramePlugin {
    id: string; // an identifier for panel
    title: string; // name for tab and admin ui
    adminOption: string; // help for admin ui
    onUpdate: (ui: JQuery, config: IContextPageConfigTab, context: IContextInformation) => void; // function to render page, if context == null, it is the initial drawing
}

class ContextFrameManagerImpl {
    private pages: IContextFramePlugin[] = [];

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    constructor() {}

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    getPages() {
        return this.pages;
    }

    // register a plugin providing  a context page
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    register(plugin: IContextFramePlugin) {
        this.pages.push(plugin);
    }

    // check if a context page is supplied by plugin
    implements(id: string): boolean {
        return !!this.getPlugin(id);
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    renderTab(panel: JQuery, id: string, config: IContextPageConfigTab, context: IContextInformation) {
        let p = this.getPlugin(id);
        p.onUpdate(panel, config, context);
    }

    // return a context page plugin of a given type
    private getPlugin(id: string): IContextFramePlugin {
        for (let idx = 0; idx < this.pages.length; idx++) {
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            if (this.pages[idx].id == id) {
                return this.pages[idx];
            }
        }
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        return null;
    }
}

let ContextFrameManager: ContextFrameManagerImpl;

// TODO: MATRIX-7555: lint errors should be fixed for next line
// eslint-disable-next-line
function InitializeTrainingManager() {
    ContextFrameManager = new ContextFrameManagerImpl();
}
